import React, { Component } from 'react';
import Button from '../Components/Button.js';
import update from 'immutability-helper';
import './UserTools.css';

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      currentUser: {
        status: 'in-progress',
        estimate: ''
      }
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.castVote = this.castVote.bind(this);
    this.skipVote = this.skipVote.bind(this);
    this.handleOnInput = this.handleOnInput.bind(this);
  }

  componentDidMount() {
    this.setState({ active: true });
    if (this.state.currentUser.status === 'in-progress' && !this.props.roomShowTotalEstimate)
      this.estimateInput.focus();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser !== this.state.currentUser)
      this.setUser(nextProps.currentUser)
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.currentUser.status !== this.props.currentUser.status)
      this.props.updateUser(nextState.currentUser)
  }

  componentDidUpdate() {
    if (this.state.currentUser.status === 'in-progress' && !this.props.roomShowTotalEstimate)
      this.estimateInput.focus();
  }

  handleChange(event) {
    this.setUser({ estimate: event.target.value });
    this.voteButtonActiveClass = event.target.value ? 'button--green' : '';
  }

  handleKeyPress(event) {
    if (event.key === 'Enter')
      this.castVote()
  }

  handleOnInput(event) {
    if (event.target.value.length > 3) {
      event.target.value = event.target.value.slice(0, 3);
    }
  }

  castVote() {
    this.setUser({
      estimate: this.estimateInput.value,
      status: 'ready'
    });
  }

  skipVote() {
    this.setUser({
      estimate: "?",
      status: 'ready'
    })
  }

  setUser(currentUser) {
    let newCurrentUser = update(this.state.currentUser, {$merge: currentUser});
    this.setState({ currentUser: newCurrentUser })
  }

  render() {
    let activeClass = (this.state.active) ? 'active' : '';
    let isReady = (!this.props.roomLastUserReady && this.state.currentUser.status === 'ready' && !this.props.roomShowEstimate);
    let isInProgress = (this.state.currentUser.status === 'in-progress');
    let isDeciding = (this.props.roomShowEstimate);
    let isShowingTotal = (this.props.roomShowTotalEstimate);

    if (isShowingTotal) {
      return (
        <div className={`user-tools estimate--deciding ${activeClass} ${this.props.roomCurrentStepType}`}>
          <div className="estimate-summary">
            <div className="estimate-title"><span role="img" aria-label="clapping">👏</span> Great estimate team!</div>
            <div className="estimate-description">Now put that on your task</div>
          </div>
        </div>
      );
    } else if (isInProgress) {
      return (
        <div className={`user-tools ${activeClass} ${this.props.roomCurrentStepType}`}>
          <Button className="button--skip" onClick={this.skipVote}>Skip</Button>
          <div className="estimate">
            <div className="label">Type for {this.props.roomCurrentStepType}</div>
            <input type="number" min="0" max="999"
              inputMode="numeric"
              pattern="[0-9]*"
              onChange={this.handleChange}
              onInput={this.handleOnInput}
              onKeyDown={this.handleKeyPress}
              ref={(input) => { this.estimateInput = input; }} />
          </div>
          <Button className={`button--vote ${this.voteButtonActiveClass}`} onClick={this.castVote}>Vote</Button>
        </div>
      );
    } else if (isReady) {
      return (
        <div className={`user-tools estimate--ready ${activeClass} ${this.props.roomCurrentStepType}`}>
          <div className="estimate-round">{this.state.currentUser.estimate}</div>
          <div className="estimate-summary">
            <div className="estimate-title">Boooom!</div>
            <div className="estimate-description">Waiting for everyone to vote...</div>
          </div>
        </div>
      );
    } else if (isDeciding) {
      return (
        <div className={`user-tools estimate--deciding ${activeClass} ${this.props.roomCurrentStepType}`}>
          <div className="estimate-summary">
            <div className="estimate-title"><span role="img" aria-label="thinking">🤔</span> Time to decide</div>
            <div className="estimate-description">Waiting on room decision...</div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Room/UserTools.js